import { useState, useMemo, type PropsWithChildren } from "react";

import {
  type PurchaseState,
  PurchaseStateContext,
  type PurchaseStateContextValue,
} from "./PurchaseStateContext";

export const PurchaseStateContextProvider = ({
  children,
}: PropsWithChildren) => {
  const [purchaseState, setPurchaseState] = useState<PurchaseState>(null);

  const contextValue = useMemo<PurchaseStateContextValue>(
    () => ({
      purchaseState,
      updatePurchaseState: setPurchaseState,
    }),
    [purchaseState],
  );

  return (
    <PurchaseStateContext.Provider value={contextValue}>
      {children}
    </PurchaseStateContext.Provider>
  );
};
